import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR } = theme.mixins;
  return {
    root: {
      '& .surveyQuestion': {
        marginBottom: pxToRem(16),
        '& .CheckboxWrapper': {
          '& .choiceWrapper': {
            '& .customCheckedIcon': {
              width: pxToRem(18),
              height: pxToRem(18),

            },
            '& .checkedIcon': {
              width: pxToRem(18),
              height: pxToRem(18),
              '&:before': {
                width: '8px',
                height: '5px',
                position: 'absolute',
                content: '""',
                top: '50%',
                left: '50%',
                border: '2px solid rgba(255,255,255, 1)',
                borderTop: 'none',
                borderRight: 'none',
                transform: 'translate(-50% , -50%) rotate(-45deg)',
                '[dir="rtl"] &': {
                  left: 0,
                  right: 0,
                },
                '@media (min-width:1024px) and (max-width:1440px)': {
                  '[dir="rtl"] &': {
                    right: '-2px',
                  },
                }
              },
            }
          }
        },
        '& .matrixTable': {
          '& .radioTableData': {
            '& .radio-btn-icon': {
              width: pxToRem(18),
              height: pxToRem(18),
            },
            '& .radio-btn-Chekedicon': {
              width: pxToRem(18),
              height: pxToRem(18),
              '&:before': {
                width: '8px',
                height: '8px',
                position: 'absolute',
                content: '""',
                top: '50%',
                left: '50%',
                transform: 'translate(-50% , -50%) ',
                borderRadius: '50%',
                '[dir="rtl"] &': {
                  left: 0,
                  right: 0
                },
                '@media (min-width:1024px) and (max-width:1440px)': {
                  '[dir="rtl"] &': {
                    right: '.5px',
                    width: '6px',
                    height: '6px',
                  },
                }

              },
            },
          }
        },
        [theme.breakpoints.down('lg')]: {
          '& .MuiFormControl-root': {
            width: '50%'
          },
        },
        [theme.breakpoints.down('sm')]: {
          '& .MuiFormControl-root': {
            width: '100%'
          },
        },
        '& .choiceWrapper': {
          marginTop: 0,
          '& .MuiButtonBase-root': {
            padding: '6px 5px'
          },
          '& .MuiFormControlLabel-root': {
            marginLeft: 0,
            '& .MuiFormControlLabel-label': {
              '& p': {
                fontSize: pxToRem(14),
                lineHeight: 'normal',
                [theme.breakpoints.down('md')]: {
                  fontSize: pxToRem(12),
                }
              }
            }
          },

          '& .MuiFormLabel-root': {
            marginBottom: pxToRem(10),
            fontSize: pxToRem(14),
            lineHeight: 'normal',
            [theme.breakpoints.down('md')]: {
              fontSize: pxToRem(12),
            }
          },

          '& .MuiFormGroup-root': {
            '& .radio-btn-icon': {
              width: pxToRem(18),
              height: pxToRem(18),
            },
            '& .radio-btn-Chekedicon': {
              width: pxToRem(18),
              height: pxToRem(18),
              '&:before': {
                width: '8px',
                height: '8px',
                position: 'absolute',
                content: '""',
                top: '50%',
                left: '50%',
                transform: 'translate(-50% , -50%)',
                borderRadius: '50%',
                '[dir="rtl"] &': {
                  left: 0,
                  right: 0
                },
                '@media (min-width:1024px) and (max-width:1440px)': {
                  '[dir="rtl"] &': {
                    right: '.3px',
                    width: '6px',
                    height: '6px',
                  },
                }
              },
            },
            '& .MuiTypography-root': {
              fontSize: pxToRem(14),
              lineHeight: 'normal',
              [theme.breakpoints.down('md')]: {
                fontSize: pxToRem(12),
              }
            }
          }
        },

        '& .inputFieldQuestion': {
          margin: '0 !important',
          '& .MuiInputBase-root': {
            height: 'unset !important',
            padding: '8px 0 ',
            borderRadius: '3px',
            marginLeft: '5px',
          },
          '& .MuiFormLabel-root': {
            fontSize: pxToRem(14),
            lineHeight: 'normal',
            fontFamily: theme.custom.fontFamily.primaryBold,
            marginBottom: pxToRem(6),

            [theme.breakpoints.down('md')]: {
              fontSize: pxToRem(12),
            },

            "& .MuiFormLabel-asterisk": {
              color: "#FF8707",
              fontSize: pxToRem(21),
              [theme.breakpoints.down('md')]: {
                fontSize: pxToRem(18),
              },
            }
          }
        },
      }
    },
    questionLabel: {
      fontSize: pxToRem(14),
      lineHeight: 'normal',
      letterSpacing: 0,
      fontFamily: theme.custom.fontFamily.primaryBold,
      marginBottom: pxToRem(10),
      [theme.breakpoints.down('md')]: {
        fontSize: pxToRem(12),
      },
      '& .MuiRating-icon': {
        '& .MuiSvgIcon-root': {
          width: pxToRem(13),
          height: pxToRem(13)
        }
      }
    },
    submitButton: {
      [theme.breakpoints.up('lg')]: {
        ...marginLR(pxToRem(8), pxToRem(8)),
      },
      marginLeft: '0 !important',
      '& .MuiButton-endIcon': {
        display: 'none'
      },
      '& .MuiButton-label': {
        fontFamily: theme.custom.fontFamily.primaryBold,
      },
    },
    heading: {
      fontSize: pxToRem(32),
      lineHeight: '2.5',
      marginBottom: pxToRem(32),
      fontFamily: theme.custom.fontFamily.primaryRegular,
      [theme.breakpoints.down('md')]: {
        fontSize: pxToRem(20),
      },
    },
    rating: {
      "& .MuiRating-label": {
        color: "#FF8707"
      }
    }
  };
});
export default useStyles;
